import { Box, Divider } from '@mui/material';
import { ATSPrincipalAppCandidateModalTabsTestIds } from 'data-testids/ATS';
import { Certificates } from './Certificates';
import { Credentials } from './Credentials';
import { Education } from './Education';
import { Exams } from './Exams';

export const QualificationsTab = ({ row }) => {
  return (
    <Box data-testid={ATSPrincipalAppCandidateModalTabsTestIds.QUALIFICATIONS_TAB}>
      <Credentials credentials={row.candidate.credentials} />
      <Divider />
      <Education educationItems={row.candidate.education} />
      <Divider />
      <Certificates certificates={row.candidate.certificates} />
      <Exams exams={row.candidate?.exams} />
    </Box>
  );
};
